import { render } from "./editPointgps.vue?vue&type=template&id=f4486648&scoped=true"
import script from "./editPointgps.vue?vue&type=script&lang=js"
export * from "./editPointgps.vue?vue&type=script&lang=js"

import "./editPointgps.vue?vue&type=style&index=0&id=f4486648&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4486648"]])

export default __exports__